"use client";

import * as React from "react";
import { useAuth } from "@workspace/ui/hooks/useAuth";

type RequireAuthProps = {
  children: React.ReactNode;
  /** Content to show while checking auth status */
  fallback?: React.ReactNode;
};

/**
 * Wrapper component that gates children behind authentication.
 * Redirects to login if the user is not authenticated.
 *
 * @example
 * ```tsx
 * <RequireAuth fallback={<Skeleton />}>
 *   <ProtectedPage />
 * </RequireAuth>
 * ```
 */
export function RequireAuth({ children, fallback }: RequireAuthProps) {
  const { loading, authenticated } = useAuth({ requireAuth: true });

  if (loading || !authenticated) {
    return <>{fallback ?? null}</>;
  }

  return <>{children}</>;
}
